import Cookie from "universal-cookie";

const setCookie = (cName, cValue, cPath, cDomain, cExpiry) => {
	const cookie = new Cookie();
	cookie.set(cName, cValue, {
		path: cPath,
		domain: cDomain,
		expires: cExpiry,
	});
};

const getCookie = cName => {
	const cookie = new Cookie();
	return cookie.get(cName);
};

const removeCookie = (cName, cPath, cDomain) => {
	const cookie = new Cookie();
	cookie.remove(cName, { path: cPath, domain: cDomain });
};

const setLanguageCookie = language => {
	// Set cookie date
	const expiration = new Date();
	expiration.setUTCMonth(expiration.getMonth() + 1);

	// const cookieDomain = window.location.hostname.replace(/^www\./, ".");
	const subdomainRegex = /^[^.]+\./;

	const cookieDomain = subdomainRegex.test(window.location.hostname)
		? window.location.hostname.replace(subdomainRegex, ".")
		: `.${window.location.hostname}`;

	setCookie("nf_lang", language.toLowerCase(), "/", cookieDomain, expiration);
};

export { setCookie, getCookie, removeCookie, setLanguageCookie };
